import { render, staticRenderFns } from "./TableTransfers.vue?vue&type=template&id=d95fa218&scoped=true"
import script from "./TableTransfers.js?vue&type=script&lang=js&external"
export * from "./TableTransfers.js?vue&type=script&lang=js&external"
import style0 from "./TableTransfers.vue?vue&type=style&index=0&id=d95fa218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95fa218",
  null
  
)

export default component.exports